import { Component, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of as RxOf } from 'rxjs/observable/of';
import { defer as _defer, cloneDeep as _cloneDeep } from 'lodash';

import {
  AbstractBlModal,
  ModalReason,
  BlRadioGroupComponent
} from '@blcloud/bl-ng-ui-component';

import {
  IReceptScreenActionSetting,
  FirstFocusDivArray
} from './recept-screen-action-setting-modal.define';

@Component({
  templateUrl: './recept-screen-action-setting-modal.component.html',
  styleUrls: ['./recept-screen-action-setting-modal.component.scss']
})
export class ReceptScreenActionSettingModalComponent extends AbstractBlModal {

  /** 画面動作設定 */
  _screenActionSetting: IReceptScreenActionSetting;

  /** 初期カーソル項目リスト */
  _firstFocusItems = FirstFocusDivArray.map(
    item => {
      return { code: item.value, name: item.text };
    }
  );

  /** 初期カーソル項目入力コンポーネント */
  @ViewChild('firstFocusInput') private firstFocusInput: BlRadioGroupComponent;

  constructor(
  ) {
    super();
  }

  /**
   * @override
   */
  getResults(): any {
    return this._screenActionSetting;
  }

  /**
   * @override
   */
  onShown() {
    this._screenActionSetting = _cloneDeep(this.data.screenActionSetting);

    // 初期フォーカス
    _defer(() => {
      if (this.firstFocusInput) {
        this.firstFocusInput.focus();
      }
    });
  }

  /**
   * @override
   */
  dismiss(reason: ModalReason) {
    if (reason === ModalReason.Done) {
      this.validate().subscribe(
        result => {
          if (result) {
            this.emitDismissEvent(reason);
          }
        }
      );
    } else {
      // 確定以外はそのまま通知
      this.emitDismissEvent(reason);
    }
  }

  // ================================================================
  // private

  /**
   * 入力検証します。
   * @returns 検証結果
   */
  private validate(): Observable<boolean> {
    return RxOf(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/recept-screen-action-setting-modal/recept-screen-action-setting-modal.component.ts